/* ============================================================
   WOW Graphics — interactions only
   Chrome (ticker/header/footer) and all data now come from Liquid
   sections. This file just wires behaviour:
   sticky header · cart drawer · mobile nav · accordion ·
   reveal-on-scroll · carousel arrows · add-to-cart toast.
   ============================================================ */
(function () {
  "use strict";

  function wire() {
    // ---- sticky header shadow ----
    var hdr = document.getElementById("siteHdr");
    if (hdr) {
      var onScroll = function () { hdr.classList.toggle("scrolled", window.scrollY > 8); };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    // ---- cart drawer ----
    var drawer = document.getElementById("cartDrawer");
    var scrim = document.querySelector(".drawer-scrim");
    var openCart = function () { if (drawer) drawer.classList.add("open"); if (scrim) scrim.classList.add("open"); };
    var closeCart = function () { if (drawer) drawer.classList.remove("open"); if (scrim) scrim.classList.remove("open"); };
    document.querySelectorAll("[data-open-cart]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openCart(); }); });
    document.querySelectorAll("[data-close-cart]").forEach(function (b) { b.addEventListener("click", closeCart); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    // ---- mobile nav ----
    var burger = document.querySelector("[data-burger]");
    if (burger) burger.addEventListener("click", function () {
      var nav = document.querySelector(".hdr-nav");
      if (!nav) return;
      var open = nav.style.display === "flex";
      nav.style.cssText = open ? "" : "display:flex;position:absolute;top:100%;left:0;right:0;flex-direction:column;background:var(--bg2);border-bottom:1px solid var(--line);padding:16px clamp(18px,4vw,48px);gap:14px;";
    });

    // ---- accordion (FAQ / Terms) ----
    document.querySelectorAll("[data-acc] .acc-head").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.closest(".acc-item");
        var open = item.classList.contains("open");
        item.parentElement.querySelectorAll(".acc-item.open").forEach(function (o) { o.classList.remove("open"); });
        if (!open) item.classList.add("open");
      });
    });

    // ---- reveal on scroll ----
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.14 });
    document.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });

    // ---- carousel arrows ----
    document.querySelectorAll("[data-carousel]").forEach(function (car) {
      var track = car.querySelector("[data-track]");
      if (!track) return;
      var scope = car.closest(".section") || document;
      scope.querySelectorAll("[data-scroll]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var dir = btn.dataset.scroll === "next" ? 1 : -1;
          track.scrollBy({ left: dir * Math.min(620, track.clientWidth * 0.8), behavior: "smooth" });
        });
      });
    });

    // ---- add-to-cart toast (visual confirmation) ----
    document.querySelectorAll("[data-toast]").forEach(function (b) {
      b.addEventListener("click", function () {
        var t = document.querySelector(".toast");
        if (!t) { t = document.createElement("div"); t.className = "toast"; document.body.appendChild(t); }
        var ic = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
        t.innerHTML = '<span class="toast-ic">' + ic + '</span><div><strong>Added to cart</strong><span>' + (b.dataset.toast || "Item added") + "</span></div>";
        requestAnimationFrame(function () { t.classList.add("show"); });
        clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove("show"); }, 3800);
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
})();
